import { EMPTY_TRANSLATIONS, Translations } from '../../domain/entities/translations';

import { RawJson, asRecord, isRecord, readRecord } from './raw-json';

const ROOT_KEYS = ['i18n', 'translations', 'strings'] as const;
const KEY_SEPARATOR = '.';

export function toTranslations(payload: unknown): Translations {
  const root = readRecord(asRecord(payload), ...ROOT_KEYS);

  if (root === null) {
    return EMPTY_TRANSLATIONS;
  }

  const flattened: Record<string, string> = {};
  collect(root, '', flattened);
  return flattened;
}

function collect(source: RawJson, prefix: string, target: Record<string, string>): void {
  for (const [key, value] of Object.entries(source)) {
    const path = prefix.length === 0 ? key : `${prefix}${KEY_SEPARATOR}${key}`;

    if (isRecord(value)) {
      collect(value, path, target);
    } else if (typeof value === 'string') {
      target[path] = value;
    } else if (typeof value === 'number' || typeof value === 'boolean') {
      target[path] = String(value);
    }
  }
}
